import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileNavigation from './MobileNavigation';
import TrialBanner from '../upgrade/TrialBanner';
import ImpersonationBanner from '../impersonation/ImpersonationBanner';

const AppLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      {/* Impersonation banner — sticky-top, only renders during a session.
          Sits above the trial banner so super-admin context always wins. */}
      <ImpersonationBanner />

      {/* Trial banner — auto-hides when no trial is active */}
      <TrialBanner />

      {/* Mobile sidebar overlay */}
      <AnimatePresence>
        {sidebarOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-gray-600 bg-opacity-50 lg:hidden"
            onClick={closeSidebar}
          />
        )}
      </AnimatePresence>

      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      {/* Main content area */}
      <div className="lg:ml-64">
        {/* Header */}
        <Header onMenuClick={toggleSidebar} />

        {/* Main content */}
        <main className="p-4 lg:p-6 mobile-safe-bottom">
          <Outlet />
        </main>
      </div>

      {/* Mobile navigation */}
      <MobileNavigation className="lg:hidden" />
    </div>
  );
};

export default AppLayout;
